import React from "react";
import Avatar from "../../../Experimental/General/components/Avatar/Avatar";
import {getMentorDynamicImageSrc} from "../MentorDynamicImage/MentorDynamicImage";

export function MentorAvatar({mentor, ...props}) {
    const profilePhoto = getMentorDynamicImageSrc(mentor.profilePhoto);
    return (
        <Avatar
            {...props}
            alt={mentor.firstName ? `${mentor.firstName} profile photo` : "bot profile photo"}
            dynamic
            src={profilePhoto}
        />
    );
}
